import HeroSection from "../Components/HeroSection";
import FeaturesSection from "../Components/FeaturesSection";
import CategoriesSection from "../Components/CategoriesSection";
import Newsletter from "../Components/Newsletter/Newsletter";
import React from "react";

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <CategoriesSection />
      <Newsletter />
    </>
  );
};

export default HomePage;
